export const isNumeric = (value?: number | string | undefined) => {
  if (typeof value !== "string" && typeof value !== "number") {
    return false;
  }

  if (typeof value === "string") {
    return !isNaN(parseFloat(value));
  } else {
    return !isNaN(value);
  }
};